import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Hospital {
  id: string;
  name: string;
  slug: string;
  email?: string;
  phone?: string;
  address?: string;
  logo_url?: string;
}

interface HospitalStore {
  currentHospital: Hospital | null;
  setHospital: (hospital: Hospital) => void;
  clearHospital: () => void;
  hospitals: Hospital[];
  setHospitals: (hospitals: Hospital[]) => void;
}

export const useHospital = create<HospitalStore>()(
  persist(
    (set) => ({
      currentHospital: null,
      hospitals: [],
      setHospital: (hospital) => set({ currentHospital: hospital }),
      clearHospital: () => set({ currentHospital: null }),
      setHospitals: (hospitals) => set({ hospitals }),
    }),
    {
      name: 'hospital-storage',
    }
  )
);

export type { Hospital, HospitalStore };

